import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { useDialogs } from '../../../../../hooks';
import { appointmentShape } from '../../../../../types';
import { getAppointmentColor, isWithinWorkday } from '../../../../../utils';
import { TIME_SLOT_HEIGHT } from '../../constants';
import Appointment from './Appointment';
import OverflowMenu from './OverflowMenu';

const MAX_VISIBLE_APPOINTMENTS = 2;

const DateTimeCell = ({ appointments, time }) => {
  const {
    handleNewAppointmentClick: onNewAppointmentClick,
    handleOpenAppointmentDialog: onOpenAppointmentDialog,
  } = useDialogs();

  const handleAppointmentClick = (appointment) => () =>
    onOpenAppointmentDialog(appointment);

  const handleCellClick = (e) => {
    if (e.target === e.currentTarget) onNewAppointmentClick();
  };

  const cellStyles = cn(
    'flex gap-px p-px border-b border-r transition-colors hover:bg-muted/60',
    !isWithinWorkday(time) && 'bg-muted/40'
  );

  const overflowAppointments = appointments.slice(MAX_VISIBLE_APPOINTMENTS);
  const visibleAppointments = appointments.slice(0, MAX_VISIBLE_APPOINTMENTS);

  return (
    <div
      className={cellStyles}
      onClick={handleCellClick}
      style={{ height: TIME_SLOT_HEIGHT }}
    >
      {visibleAppointments.map((appointment) => (
        <div className="flex flex-1 min-w-0" key={appointment.id}>
          <Appointment
            color={getAppointmentColor(appointment)}
            endAt={appointment.endAt}
            onClick={handleAppointmentClick(appointment)}
            startAt={appointment.startAt}
            title={appointment.title}
          />
        </div>
      ))}

      {overflowAppointments.length > 0 && (
        <div className="flex flex-1 min-w-0">
          <OverflowMenu
            appointments={overflowAppointments}
            onAppointmentClick={onOpenAppointmentDialog}
          />
        </div>
      )}
    </div>
  );
};

DateTimeCell.propTypes = {
  appointments: PropTypes.arrayOf(appointmentShape).isRequired,
  time: PropTypes.string.isRequired,
};

export default DateTimeCell;
